import React, { useContext, useRef } from 'react';
import classnames from 'classnames';
import get from 'lodash/get';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { useDeviationViewContext } from '../../Context';
import DeviationFullView from '../../DeviationViews/Full';
import DuperbrowsePaddles from '../../Duperbrowse/DuperbrowsePaddles';
import StageBackground from '../../DeviationBackground/StageBackground';
import { SubscriptionPurchaseFTUEContext } from '../../Tier/ftue/SubscriptionPurchaseFTUE/SubscriptionPurchaseFTUEContext';
import SubscriptionPurchaseFTUE from '../../Tier/ftue/SubscriptionPurchaseFTUE/SubscriptionPurchaseFTUE';
import StageContainer from '../_partials/StageContainer';
import { useMeasuredStage } from '../hooks/useMeasuredStage';
import { useSelector } from 'react-redux';
import { getCurrentAdSafety } from '../../Ads/redux/selectors';
import { useShouldRenderAdArea } from '@wix/da-ads/pkg/useShouldRenderAdArea';
import { useAdsType } from '@wix/da-ads/pkg/useAdsType';
import s from './DesktopArtStage.scss';
export const DesktopArtStage = ({ deviation, className, isZoomed, onEnterZoomMode = ()=>null, onExitZoomMode = ()=>null })=>{
    const { isFullscreen } = useDeviationViewContext();
    const ref = useRef(null);
    const { contentSize, containerSize } = useMeasuredStage(ref, !isFullscreen);
    // Ads
    const { adsEnabled } = useContext(SessionContext);
    const adSafety = useSelector((state)=>getCurrentAdSafety(state));
    const adsType = useAdsType();
    const showAd = useShouldRenderAdArea(adSafety) && adsType === 'anon';
    const isSubscriptionPurchaseFTUEBeingShown = !!useContext(SubscriptionPurchaseFTUEContext);
    return /*#__PURE__*/ React.createElement(StageContainer, {
        className: classnames(s['root'], className, isFullscreen && s['fullscreen'], showAd && adsEnabled && s['with-ad'])
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['content'],
        ref: ref
    }, /*#__PURE__*/ React.createElement(StageBackground, {
        deviation: deviation,
        height: get(containerSize, 'height'),
        width: get(containerSize, 'width')
    }), /*#__PURE__*/ React.createElement(DeviationFullView, {
        deviation: deviation,
        height: get(contentSize, 'height'),
        width: get(contentSize, 'width'),
        isZoomed: isZoomed,
        onEnterZoomMode: onEnterZoomMode,
        onExitZoomMode: onExitZoomMode
    }), /*#__PURE__*/ React.createElement(DuperbrowsePaddles, {
        className: s['duperbrowse']
    }), isSubscriptionPurchaseFTUEBeingShown && /*#__PURE__*/ React.createElement(SubscriptionPurchaseFTUE, null)));
};
DesktopArtStage.displayName = 'DesktopArtStage';
export default DesktopArtStage;
